import { render, staticRenderFns } from "./SignatureComponent.vue?vue&type=template&id=bd63bd6c&scoped=true&"
import script from "./SignatureComponent.vue?vue&type=script&lang=js&"
export * from "./SignatureComponent.vue?vue&type=script&lang=js&"
import style0 from "./SignatureComponent.vue?vue&type=style&index=0&id=bd63bd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd63bd6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
